import type {Result} from 'framework';
import type {CopyMealCommand} from '../../domain/copy-meal-command';
import type {DashboardError} from '../../domain/errors';
import type {MealDetail} from '../../domain/meal-detail';
import type {MealId} from '../../domain/meal-id.value-object';
import type {DashboardRepository} from '../ports/dashboard.repository';

export interface CopyMealInput {
  readonly mealId: MealId;
  readonly command?: CopyMealCommand;
}

export class CopyMeal {
  constructor(private readonly dashboardRepository: DashboardRepository) {}

  execute(input: CopyMealInput): Promise<Result<MealDetail, DashboardError>> {
    return this.dashboardRepository.copyMeal({
      mealId: input.mealId,
      command: input.command ?? {},
    });
  }
}
